import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import GlobalOffices from '../components/GlobalOffices';
import { City } from '../types';
import { trackOfficesViewed } from '../src/lib/analytics';

const OfficesPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // 更新页面标题
  useEffect(() => {
    document.title = `${t('nav.globalOffices')} - ${t('html.title')}`;
    trackOfficesViewed();
  }, [t]);

  const handleSelectCity = (city: City) => {
    navigate(`/cities/${city.id}`);
  };

  const handleBack = () => {
    navigate('/');
  };

  return (
    <GlobalOffices
      onSelectCity={handleSelectCity}
      onBack={handleBack}
    />
  );
};

export default OfficesPage;
